import { PagedSingleSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { bottomNavBarItemService } from "../api/bottomNavBarService";

interface Props {
	name: string;
	label: string;
	clearable?: boolean;
	required?: boolean;
	disabled?: boolean;
}

const fetchConfig = laravelServiceSelectFetchConfig(bottomNavBarItemService);

export const BottomNavBarItemSingleSelect: FC<Props> = ({ name, label, clearable, required, disabled }) => {
	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			clearable={clearable}
			required={required}
			disabled={disabled}
			fetchConfig={fetchConfig}
		/>
	);
};
